
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { FC, useEffect } from 'react';
import useTranslation from 'next-translate/useTranslation';
import ChatPanel from '../components/ChatPanel';
import useRecommendedForYou from '../services/recommendationsAPI/useRecommendedForYou';
import { AnalyticsProductCarouselTypes } from '../utils/types/analytics';
import ProductCarousel from '../components/Carousels/ProductCarousel';
import styles from '../styles/404.module.less';
const Error404: FC = () => {
    const { t } = useTranslation('common');
    const { data: recommendedForYouProducts, triggerHomePageView, isLoading, } = useRecommendedForYou({ pageSize: 20 });
    useEffect(() => {
        triggerHomePageView();
    }, []);
    return (<div className={`${styles.container} max-width-m`}>
      <div className={styles['not-found-content']}>
        <h2 className="title">
          {t('Oops! 404, this page not found')}
        </h2>

        <p className="subtitle">
          {t('Ask about an alternative option by contacting a product specialist')}
        </p>

        <ChatPanel className={`${styles['chat-panel']} margin-top-spacer-double`} customTextContent={t('modals:Get help from our experts')} chatPanelCtaText={t('modals:Chat with us')}/>

        <ProductCarousel carouselType={AnalyticsProductCarouselTypes.RecommendedForYou} productCardType="narrow" title={t('products:Recommended for you')} products={recommendedForYouProducts} className="margin-top-spacer-quadruple margin-bottom-spacer-quadruple" testId="recommended-carousel-404" hasBackgroundWrapper carouselGap={20} isLoading={isLoading}/>
      </div>
    </div>);
};
export default Error404;

    async function __Next_Translate__getStaticProps__19962971b25__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/404',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19962971b25__ as getStaticProps }
  